export default {"src":"/_next/static/media/No connection.a5620bd4.svg","height":360,"width":360,"blurWidth":0,"blurHeight":0};